<template>
  <div class="chat-page">
    <div class="chat-wrap">
      <div class="chat-header">
        <div class="chat-title">智能客服</div>
        <div class="chat-sub-title">为您解答疑惑</div>
      </div>
      <div class="chatContent">
        <div class="chatBox">
          <div class="chat-main">
            <div id="chatInfomationBox" class="chat-info-list innerbox">
              <div v-for="(chat, index1) in answerList" :key="'chat' + index1">
                <div>
                  <center style="margin: 10px">
                    <span class="time" v-if="chat.date">{{ chat.date }}</span>
                  </center>
                  <div
                    v-if="chat.type === 'answer'"
                    class="info-line answer-line"
                  >
                    <img src="../src/assets/znwd/headset.png" alt="icon" />

                    <div
                      v-if="!chat.answerTitleOne"
                      class="answer"
                      v-html="chat.text"
                    >
                      <div v-if="chat.linkList.length">
                        <div
                          v-for="(link, index2) in chat.linkList"
                          :key="'chatLink' + index2"
                          class="link-row"
                        >
                          <el-link
                            :href="link.url"
                            type="primary"
                            target="_blank"
                          >
                            {{ link.text }}
                          </el-link>
                        </div>
                      </div>
                    </div>
                    <!-- 匹配得到问题 -->
                    <div class="ppTjBox" v-else>
                      <div class="wtHeader">{{ chat.answerTitleOne }}</div>
                      <div
                        v-for="(link, index2) in chat.textList"
                        :key="'chatLink' + index2"
                        class="link-row"
                      >
                        <!-- 问答 -->
                        <el-link
                          v-if="link.type === 1"
                          type="primary"
                          target="_blank"
                          @click="onConfirm(link)"
                        >
                          {{ link.title }}
                        </el-link>
                        <!-- 跳转 -->
                        <el-link
                          v-else
                          :href="link.pcLink"
                          type="primary"
                          target="_blank"
                        >
                          {{ link.title }}
                        </el-link>
                      </div>
                    </div>

                    <i
                      class="iconfont icon-yuyin"
                      v-if="OpenEnabled"
                      @click="
                        palyFn(
                          chat.text ? chat.text : chat.answerTitleOne,
                          chat.textList
                        )
                      "
                    ></i>
                  </div>
                  <div v-else class="info-line question-line">
                    <div class="question" @click="palyYyFn(chat.luYin)">
                      {{ chat.text }}
                      <i
                        v-if="chat.luYin"
                        class="iconfont icon-yuyin-cuxiantiao"
                      >
                      </i>
                    </div>
                  </div>
                  <!-- 初始问候语 -->
                  <div
                    class="yuyinBox"
                    v-if="
                      chat.answerTitle &&
                      chat.recommendKeywordVos &&
                      chat.recommendKeywordVos.length > 0
                    "
                  >
                    <div class="tjBox">
                      <div class="wtHeader">{{ chat.answerTitle }}</div>
                      <div class="tjContent">
                        <span
                          class="tag"
                          @click="handleSend(item.keyword)"
                          v-for="(item, index) in chat.recommendKeywordVos"
                          :key="index"
                          >{{ item.keyword }}
                        </span>
                      </div>
                    </div>
                    <!-- <i class="iconfont icon-yuyin" @click="palyFn( chat.answerTitle)"></i> -->
                  </div>
                  <!-- 发送问题 -->
                  <div class="tjBox" v-if="chat.linkList.length">
                    <div class="wtHeader">{{ chat.answerTitles }}</div>
                    <div class="tjContent">
                      <span
                        class="tag"
                        @click="handleSend(item.text)"
                        v-for="(item, index) in chat.linkList"
                        :key="index"
                        type="primary"
                        round
                        >{{ item.text }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="chat-input">
            <i
              v-if="OpenEnabled"
              class="iconfont icon-yuyin1-copy iconLuyin"
              @click="dialogVisible = true"
            ></i>
            <textarea
              class="keyword-input innerbox"
              v-model="keyWord"
              placeholder="输入您问题的关键字可搜索"
              @keyup.enter="handleSend('')"
              @focus="placeholderHind"
              @blur="placeholderShow"
              ref="textarea"
            >
            </textarea>

            <button class="chat-send-btn" @click="handleSend('')">发送</button>
          </div>
        </div>
        <div class="commonProblem">
          <div class="commonHeader">常见问题</div>

          <!-- <ul>
            <li></li>
          </ul> -->
          <div
            class="commonTitle"
            v-for="(item, index) in columns"
            :key="index"
            @click="onConfirm(item)"
          >
            {{ item.question }}
          </div>
          <div @click="InAbBtch" class="pagination" v-if="pageTotal > 10">
            <i class="iconfont icon-huanyipi1"></i>
            <span style="margin-left: 5px">换一批</span>
          </div>
        </div>
      </div>
    </div>
    <audio ref="audio"></audio>
    <el-dialog
      title="语音输入"
      top="30vh"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
    >
      <center>
        <div class="ksLuyin" @click="handleStart" v-if="lyShow">
          <div><i class="iconfont icon-yuyin1-copys"> </i></div>
          <div>点击说话</div>
        </div>
        <div class="ksLuyin" v-else>
          <div><i class="iconfont icon-yuyin1-copys"> </i></div>
          <div>请说</div>
        </div>
      </center>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDestroy">取 消</el-button>
        <el-button type="primary" @click="sendYuyin">发送</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Recorder from 'js-audio-recorder'
// 定义网页标题名称
document.title = process.env.VUE_APP_TITLE
import { intelligentChatChat, intelligentChatInit, intelligentChatCommon, transitionAudio, intelligentChatAudio, getOpenEnabled } from '@/api/znwd'
function isNull (str) {
  if (str === '') return true
  const regu = '^[ ]+$'
  const re = new RegExp(regu)
  return re.test(str)
}
export default {
  name: 'aiChat',
  data () {
    return {
      dialogVisible: false,
      lyShow: true,
      recorder: null,
      keyWord: '',
      answerList: [],
      columns: [],
      pageData: {
        pageSize: 10,
        pageNum: 0
      },
      pageTotal: "",//右侧列表总条数
      OpenEnabled: ""
    }
  },
  created () {
    // this.getList('')
    this.initRecorder()
    this.initList()
    this.getOpenEnabled()
  },
  mounted () {
    this.$nextTick(() => {
      intelligentChatInit().then(res => {//初始问候语
        let aer = res.data.data
        this.answerList.push({
          type: 'answer',
          text: aer.systemAnswer,
          url: '',
          linkList: [],
          answerTitle: aer.answerTitle,
          date: this.CurentTime(),
          recommendKeywordVos: aer.recommendKeywordVos
        })

      })

    })
  },
  methods: {
    getOpenEnabled () {//是否开启语音识别功能
      getOpenEnabled().then(res => {
        this.OpenEnabled = res.data.data

      })
    },
    initRecorder () {//创建录音实例
      this.recorder = new Recorder(
        {
          sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
          sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
          numChannels: 1
        }
      )
    },
    palyYyFn (val) {//播放自己发送的语音
      if (val) {
        val.play()
      }
    },
    sendYuyin () {
      this.dialogVisible = false
      this.uploadRecord()
      this.answerList.push({
        type: 'question',
        text: this.recorder.duration.toFixed(1),
        linkList: [],
        date: this.CurentTime(),
        luYin: this.recorder
      })

      this.updateScroll()
    },
    handleDestroy () {
      this.lyShow = true
      this.dialogVisible = false,
        this.recorder.destroy() // 毁实例
      // this.timer = null
    },
    handleStart () {
      this.initRecorder()
      Recorder.getPermission().then(() => {
        console.log('开始录音')
        this.recorder.start() // 开始录音
        console.log(123);
        this.lyShow = false
      }, (error) => {
        this.$message({
          message: '请先允许该网页使用麦克风',
          type: 'info'
        })
        console.log(`${error.name} : ${error.message}`)
      })
    },
    //上传录音
    uploadRecord () {
      // this.list.push(this.recorder)
      // console.log(135, this.list);
      if (this.recorder == null || this.recorder.duration === 0) {
        this.$message({
          message: '请先录音',
          type: 'error'
        })
        return false
      }
      this.recorder.pause() // 暂停录音
      this.timer = null
      console.log('上传录音')// 上传录音

      const formData = new FormData()
      const blob = this.recorder.getWAVBlob()// 获取pcm格式音频数据
      // 此处获取到blob对象后需要设置fileName满足当前项目上传需求，其它项目可直接传把blob作为file塞入formData
      const newbolb = new Blob([blob], { type: 'audio/wav' })
      const fileOfBlob = new File([newbolb], new Date().getTime() + '.wav')
      formData.append('file', fileOfBlob)
      formData.append('source', 1)
      const url = window.URL.createObjectURL(fileOfBlob)
      console.log(143, fileOfBlob);
      this.src = url
      intelligentChatAudio(formData).then(res => {
        this.lyShow = true
        this.getList(res.data.data.text, true)//调接口的发送


        // this.handleSend(res.data.data.text)
        console.log(res)
      })
    },
    //播放客服返回的信息
    palyFn (val, list) {
      let str = ""
      if (list) {
        list.forEach(item => {
          str += item.title + "。"
        })
      }
      if (this.is_play) {

        this.$refs.audio.pause();
        this.is_play = false

      } else {
        transitionAudio({ text: val + str }).then(res => {
          this.$refs.audio.src = res.data.data;
          this.$refs.audio.play();
          this.is_play = true
        })
      }


    },
    placeholderHind () {
      let textarea = this.$refs.textarea
      textarea.setAttribute("placeholder", "")
    },
    placeholderShow () {
      let textarea = this.$refs.textarea
      textarea.setAttribute("placeholder", "输入您问题的关键字可搜索")
    },
    onConfirm (val) {
      // console.log(val);
      //调用该函数的有不同字段 用三元表达式进行统一
      let vals = val.question ? val.question : val.title
      this.clickSend(vals)
      setTimeout(() => {
        this.answerList.push({
          type: 'answer',
          text: val.answer ? val.answer : "暂未找到你询问的问题",
          linkList: [], date: this.CurentTime(),
        })
        this.updateScroll()
      }, 300)
    },
    InAbBtch () {
      //换一批  由于this.pageData.pageNum初始值是0 所以这里判断先给他加一
      if (this.pageTotal > this.pageData.pageSize * (this.pageData.pageNum + 1)) {
        this.pageData.pageNum++
        this.initList()
      } else {
        this.pageData.pageNum = 0
        this.initList()
      }

    },
    initList () {
      intelligentChatCommon(this.pageData).then(res => {
        this.columns = res.data.data.content
        this.pageTotal = res.data.data.totalElements
      })
    },


    //  发送
    handleSend (val) {
      //需要调接口的发送

      if (val !== '') {
        this.keyWord = val
      }
      if (isNull(this.keyWord)) {
        this.$message({
          type: 'info',
          message: '请输入关键字'
        })
        return
      }

      // console.log(213, this.keyWord);
      this.getList(this.keyWord)
      this.keyWord = ''
      this.updateScroll()
    },

    //获取问答列表
    getList (title, ber) {
      intelligentChatChat({ text: title, source: 1 }).then((res) => {
        let data = res.data.data
        console.log(249, data);
        if (ber) {
          this.answerList.push({
            type: 'question',
            text: data.text,
            linkList: [],
          })
        } else {
          this.answerList.push({
            type: 'question',
            text: data.text,
            linkList: [], date: this.CurentTime(),
          })
        }

        // console.log(223, data);
        setTimeout(() => {
          let list = null;
          // 结束场景和匹配不到问题的场景
          if (!data.chatAnswerVos && data.systemAnswer) {
            // console.log('结束场景和匹配不到问题的场景');
            list = {
              type: 'answer',
              text: data.systemAnswer,
              linkList: [],
              answerTitles: data.answerTitle,
              date: this.CurentTime(),
            }
            if (data.recommendKeywordVos) {
              data.recommendKeywordVos.forEach(item => {
                list.linkList.push({
                  text: item.keyword,
                  url: ""
                })
              })
            }

          } else {
            //匹配得到数据
            // console.log('匹配得到数据', data);
            list = {
              type: 'answer',
              answerTitleOne: data.answerTitle,
              textList: data.chatAnswerVos,
              linkList: [],
              date: this.CurentTime(),
            }

          }

          this.answerList.push(list)
          this.updateScroll()
        }, 300)
        this.updateScroll()
      })
    },
    clickSend (val) {//不需要调接口的发送
      if (val !== '') {
        this.keyWord = val
      }
      if (isNull(this.keyWord)) {
        this.$message({
          type: 'info',
          message: '请输入关键字'
        })
        return
      }
      this.answerList.push({
        type: 'question',
        text: this.keyWord,
        linkList: [],
        date: this.CurentTime(),
      })
      this.keyWord = ''
      this.updateScroll()
    },
    updateScroll () {
      this.$nextTick(() => {
        const element = document.getElementById('chatInfomationBox')
        element.scrollTop = element.scrollHeight
      })
    },
    CurentTime () {
      var now = new Date();
      var year = now.getFullYear();       //年
      var month = now.getMonth() + 1;     //月
      var day = now.getDate();            //日
      var hh = now.getHours();            //时
      var mm = now.getMinutes();          //分
      var clock = year + "-";
      if (month < 10)
        clock += "0";
      clock += month + "-";
      if (day < 10)
        clock += "0";
      clock += day + " ";
      if (hh < 10)
        clock += "0";
      clock += hh + ":";
      if (mm < 10) clock += '0';
      clock += mm;
      return (clock);
    },
  }
}
</script>

<style lang="less" scoped>
.ksLuyin {
  width: 80px;
  height: 80px;
  color: #fff;
  border-radius: 40px;
  background-color: #409eff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
textarea {
  border: none;
  overflow-y: hidden;
}
textarea:focus {
  outline: none;
}
.chatContent {
  display: flex;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  .chatBox {
    width: 600px;
  }
  .commonProblem {
    position: relative;
    flex: 1;
    height: 561px;
    background-color: #fff;
    border-left: 1px solid #ebebeb;
    border-radius: 0 0 10px 0;
    .commonHeader {
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
      border-bottom: 1px solid #ebebeb;
    }
    .commonTitle {
      margin-left: 20px;
      font-size: 14px;
      line-height: 22px;
      position: relative;
      color: #000;
      margin-bottom: 3px;
      cursor: pointer;
      padding-left: 8px;
    }
    .commonTitle:hover {
      color: #409eff;
      // .commonTitle::before {
      //   background-color: #409eff;
      // }
    }

    .commonTitle::before {
      content: "·";
      position: absolute;
      // background-color: #000;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      left: -9px;
      top: -2px;
      font-size: 40px;
    }
    .pagination {
      position: absolute;
      bottom: 165px;
      right: 20px;
      cursor: pointer;
      color: #45a1ff;
    }
    ul {
      list-style-type: disc;
      list-style-position: inside;
      font-size: 14px;
      li {
        // height: 30px;
        line-height: 30px;
        width: 208px;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
      }
      li:hover {
        cursor: pointer;
        color: #45a1ff;
      }
    }
  }
}

.chat-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 1000px;
  background-size: cover;
  background-position: center;
  background-image: url("../src/assets/sy/bj-2.png");
  display: flex;
  justify-content: center;
  align-items: center;
}

.chat-wrap {
  width: 850px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.08);
}

.chat-header {
  height: 100px;
  background: #002c95;
  color: #ffffff;
  border-radius: 10px 10px 0 0;
  padding-left: 20px;
  .chat-title {
    font-size: 20/16em;
    padding-top: 20px;
  }
  .chat-sub-title {
    font-size: 14/16em;
    padding-top: 10px;
  }
}

.chat-main {
  height: 400px;
  background: #ffffff;
  overflow: hidden;
  position: relative;
  border-bottom: 1px solid #ebebeb;

  .chat-info-list {
    padding: 20px;
    height: 360px;
    width: 560px;
    overflow-y: auto;
    .time {
      font-size: 12px;
      height: 14px;
      line-height: 14px;
      padding: 2px 3px;
      color: #fff;
      background-color: #e4e4e4;
      border-radius: 9px;
    }
    .ppTjBox {
      width: 330px;
      background-color: #f2f2f2;
      border-radius: 5px;
      margin-left: 10px;
      padding-bottom: 10px;
      .link-row {
        padding: 10px;
      }
      .wtHeader {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        padding-left: 10px;
        border-bottom: 1px solid #e4e4e4;
      }
      .tjContent {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding: 10px;
        .tag {
          background-color: #a7d2f9;
          color: #fff;
          margin-right: 10px;
          margin-bottom: 10px;
          padding: 2px 8px;
          border-radius: 20px;
          font-size: 13px;
          cursor: pointer;
          &:hover {
            color: rgba(153, 153, 153, 0.8);
          }
        }
      }
    }
    .yuyinBox {
      display: flex;
      justify-content: flex-start;
    }
    .tjBox {
      width: 330px;
      background-color: #f2f2f2;
      border-radius: 5px;
      margin-left: 37px;
      .link-row {
        padding: 5px;
      }
      .wtHeader {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        padding-left: 10px;
        border-bottom: 1px solid #e4e4e4;
      }
      .tjContent {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding: 10px;
        .tag {
          background-color: #a7d2f9;
          color: #fff;
          margin-right: 10px;
          margin-bottom: 10px;
          padding: 2px 8px;
          border-radius: 20px;
          font-size: 13px;
          cursor: pointer;
          &:hover {
            color: rgba(153, 153, 153, 0.8);
          }
        }
      }
    }
  }

  .info-line {
    display: flex;
    align-items: flex-start;
    font-size: 14/16em;
  }
  .answer-line {
    margin-bottom: 10px;
    img {
      margin-top: 5px;
      width: 28px;
    }
    .answer {
      position: relative;
      max-width: 300px;
      margin-left: 10px;
      padding: 10px;
      background: #f2f2f2;
      color: #000000;
      border-radius: 4px;
    }
    .answer::before {
      content: " ";
      border-left: 0px solid #f2f2f2;
      border-top: 10px solid transparent;
      border-right: 15px solid #f2f2f2;
      border-bottom: 10px solid transparent;
      position: absolute;
      left: -10px;
      top: 10px;
    }
    .link-text {
      margin-top: 10px;
      line-height: 24px;
      color: #356ae6; //#409eff;
    }
  }
  .question-line {
    justify-content: flex-end;
    margin-bottom: 10px;
    .question {
      max-width: 300px;
      word-wrap: break-word;
      word-break: normal;
      line-height: 25px;
      color: #ffffff;
      padding: 8px 10px;
      background-color: #356ae6; //#409eff;//#dbe6ff;
      border-radius: 4px;
      position: relative;
      cursor: pointer;
    }
    .question::after {
      content: " ";
      border-left: 15px solid #356ae6;
      border-top: 10px solid transparent;
      border-right: 0px solid #356ae6;
      border-bottom: 10px solid transparent;
      position: absolute;
      right: -10px;
      top: 8px;
    }
  }
}

.chat-input {
  height: 160px;
  border-radius: 0 0 0 10px;
  background: #ffffff;
  position: relative;
  .keyword-input {
    width: 600px !important;
    height: 150px !important;
    font-size: 14/16em;
    resize: none;
    padding: 10px 30px;
    box-sizing: border-box;
  }

  .chat-send-btn {
    position: absolute;
    right: 15px;
    bottom: 5px;
    padding: 8px 20px;
    color: #ffffff;
    border-color: #356ae6;
    background-color: #356ae6;
    border-radius: 4px;
    font-size: 14/16em;
    &:active {
      border-color: rgba(53, 106, 230, 0.8);
      background-color: rgba(53, 106, 230, 0.8);
    }
  }
}
/*滚动条样式*/
.innerbox::-webkit-scrollbar {
  width: 4px;
}
.innerbox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.3);
}
//语音图标
@font-face {
  font-family: "iconfont"; /* Project id 3088463 */
  src: url("//at.alicdn.com/t/font_3088463_btx8q2ik62n.woff2?t=1649903781004")
      format("woff2"),
    url("//at.alicdn.com/t/font_3088463_btx8q2ik62n.woff?t=1649903781004")
      format("woff"),
    url("//at.alicdn.com/t/font_3088463_btx8q2ik62n.ttf?t=1649903781004")
      format("truetype");
}
.icon-yuyin-cuxiantiao:before {
  content: "\e6b8";
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.iconLuyin {
  position: absolute;
  top: 10px;
  left: 5px;
}

.icon-yuyin1-copy:before {
  content: "\e685";
  color: #409eff;
  cursor: pointer;
}
.icon-yuyin1-copys:before {
  content: "\e685";
  color: #fff;
  cursor: pointer;
}

.icon-yuyin:before {
  content: "\e684";
  font-size: 30px;
  color: blue;
  cursor: pointer;
  margin-left: 10px;
}
@font-face {
  font-family: "iconfont"; /* Project id 3088463 */
  src: url("//at.alicdn.com/t/font_3088463_rvocks2wv1d.woff2?t=1648453346152")
      format("woff2"),
    url("//at.alicdn.com/t/font_3088463_rvocks2wv1d.woff?t=1648453346152")
      format("woff"),
    url("//at.alicdn.com/t/font_3088463_rvocks2wv1d.ttf?t=1648453346152")
      format("truetype");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-huanyipi1:before {
  content: "\e648";
}
</style>
<style scoped>
.answer-line >>> p {
  font-weight: 400;
  text-align: left;
  margin: 0;

  line-height: 1.25em;
}
.answer-line >>> * {
  /* padding: 20px 0; */
}
.answer-line >>> font {
  margin-top: 20px;
}
.answer-line >>> h1,
h2,
h3,
h4,
h5,
h6 {
  /* margin-top: 20px; */
  font-weight: 700;
}
</style>                                                                                                                                     